/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Filter_Kind_LabelInputs */

const vi_stocktake_filter_kind_label = /** @type {(inputs: Stocktake_Filter_Kind_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại kho`)
};

/**

* @param {Stocktake_Filter_Kind_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_filter_kind_label = /** @type {((inputs?: Stocktake_Filter_Kind_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Filter_Kind_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_filter_kind_label(inputs)
});